export default __webpack_public_path__ + "static/media/weather1.eaf0d51f.PNG";